import { domain } from "../../domain";

export {
    stockOut , createStockOut , store , detail
}

function stockOut(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/pos/get-stockOut?id=${id}`;
    } else if(name){
        return `${domain}/pos/get-stockOut?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/pos/get-stockOut?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}

function detail(id){
    return `${domain}/pos/get-stockOutById?id=${id}`
}

const createStockOut = `${domain}/pos/create-stockOut`;
const store = `${domain}/pos/store-stockOut`;